import { OptionBase } from 'chakra-react-select';
import { useState } from 'react';
import { GetOptionsType } from '../../../utils/metricTableTypes';

interface Option extends OptionBase {
  label: string;
  value: string;
}
// This hook manages all changes in options, i.e selecting options.
export function useHandleOptionChange() {
  const [showOption, setShowOption] = useState<GetOptionsType>('');

  const [defaultValue, setDefaultValue] = useState<Option>({
    label: '',
    value: '',
  });
  const [teamValue, setTeamValue] = useState<Option>({
    label: 'Organisation',
    value: '',
  });
  const [secondaryDefaultValue, setsecondaryDefaultValue] = useState<Option>({
    label: '',
    value: '',
  });
  const [secondaryDefaultMultiValue, setSecondaryDefaultMultiValue] = useState<
    Option[]
  >([]);
  const handleTeamOptionChange = (team: string) => {
    setTeamValue({
      value: team,
      label: team ? team : 'Organisation',
    });
  };

  const handleDefaultOptionChange = (label: string, value: string) => {
    setDefaultValue({ label, value });
  };
  const handleSecondaryDefaultMultiOptionChange = (values: Option[]) => {
    setSecondaryDefaultMultiValue(values);
  };
  const handleSecondaryDefaultOptionChange = (label: string, value: string) => {
    setsecondaryDefaultValue({ label, value });
  };
  const handleShowOptionChange = (value: GetOptionsType) => {
    setShowOption(value);
  };

  return {
    showOption,
    defaultValue,
    teamValue,
    secondaryDefaultValue,
    secondaryDefaultMultiValue,
    handleTeamOptionChange,
    handleDefaultOptionChange,
    handleSecondaryDefaultMultiOptionChange,
    handleSecondaryDefaultOptionChange,
    handleShowOptionChange,
  };
}

export default useHandleOptionChange;
